var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditNewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11.4706,
    height: 1.52941,
    transform: "matrix(-1 0 0 1 11.4707 22.1855)",
    fill: "url(#paint0_linear_1023_12671)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3812 23.1084L10.7474 16.9876L17.5078 4.15234L23.5483 7.3339L16.7879 20.1692L11.3812 23.1084Z",
    fill: "url(#paint1_linear_1023_12671)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8926 6.67919L17.8521 3.49763L19.0977 1.13276L20.8271 0.596628L24.6012 2.58448L25.1378 4.313L25.734 3.1811L25.7348 3.18156L23.8926 6.67919Z",
    fill: "#9D9D9D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1023_12671",
    x1: 0,
    y1: 0.764706,
    x2: 11.4706,
    y2: 0.764706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DA0A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DA0A7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1023_12671",
    x1: 20.1304,
    y1: 6.49814,
    x2: 13.7676,
    y2: 18.5785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D9D9D",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9D9D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditNewIcon);
export default __webpack_public_path__ + "static/media/EditNewIcon.405533f3559ac6cfa72f6f16fd826a98.svg";
export { ForwardRef as ReactComponent };